module.exports = __webpack_public_path__ + "img/steps.e8c1bb56.svg";